import { z } from 'zod';
import { BaseApplicationDTOSchema, ApplicationStatusSchema, } from "./applications.dto.js";
// Request DTO for router validation
export const UpdateApplicationStatusRequestDTOSchema = z.object({
    params: z.object({
        applicationId: BaseApplicationDTOSchema.shape.id,
    }),
    body: z.object({
        status: ApplicationStatusSchema,
    }),
});
//# sourceMappingURL=update-application-status.dto.js.map